import { generatePkceCodePair } from '../utils/pkce';
import { AuthorizationError } from '../types/AuthorizationError';
import { requestPost } from '../utils/request';

const BASE_AUTHORIZE_URL = 'https://climate.com/api';
const OIDC_AUTHORIZE_URL = '/oidc/authorize';
const AUTHORIZE_TOKEN_URL = '/oauth/token';
// TODO: ADO-50399 - Temporary client id. We have to update this with the web one.
const DEFAULT_CLIENT_ID = 'tccandroid-no-client-credentials-direct';
const DEFAULT_RESPONSE_TYPE = 'code';
const DEFAULT_REDIRECT_URI = 'https://climate.com';
const DEFAULT_SCOPE = 'user';
const DEFAULT_RESPONSE_MODE = 'direct';

const authorizeFlowId = async () => {
  const { codeVerifier, codeChallenge, codeChallengeMethod } = await generatePkceCodePair();
  const formData = new URLSearchParams();
  formData.append('client_id', DEFAULT_CLIENT_ID);
  formData.append('response_type', DEFAULT_RESPONSE_TYPE);
  formData.append('redirect_uri', DEFAULT_REDIRECT_URI);
  formData.append('scope', DEFAULT_SCOPE);
  formData.append('response_mode', DEFAULT_RESPONSE_MODE);
  formData.append('code_challenge_method', codeChallengeMethod);
  formData.append('code_challenge', codeChallenge);

  const response = await requestPost(BASE_AUTHORIZE_URL + OIDC_AUTHORIZE_URL, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData.toString(),
  });

  if (!response.ok) {
    throw new AuthorizationError(response.status, response.statusText);
  }

  const result = await response.json();

  return {
    flowId: result.flow_id,
    codeChallenge,
    codeVerifier,
  };
};

const authorizeToken = async (authorizationCode: string, codeVerifier: string) => {
  const formData = new URLSearchParams();
  formData.append('grant_type', 'authorization_code');
  formData.append('client_id', DEFAULT_CLIENT_ID);
  formData.append('redirect_uri', DEFAULT_REDIRECT_URI);
  formData.append('code', authorizationCode);
  formData.append('code_verifier', codeVerifier);
  formData.append('include_preferences', 'true');
  formData.append('include_cookies', 'true');


  const response = await requestPost(BASE_AUTHORIZE_URL + AUTHORIZE_TOKEN_URL, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData.toString(),
  });

  if (!response.ok) {
    throw new AuthorizationError(response.status, response.statusText);
  }

  return response.json();
};

export const authorizeWithPassword = async (
  email: string,
  password: string,
) => {
  const { codeVerifier, flowId } = await authorizeFlowId();
  const formData = new URLSearchParams();
  formData.append('client_id', DEFAULT_CLIENT_ID);
  formData.append('response_type', DEFAULT_RESPONSE_TYPE);
  formData.append('redirect_uri', DEFAULT_REDIRECT_URI);
  formData.append('scope', DEFAULT_SCOPE);
  formData.append('response_mode', DEFAULT_RESPONSE_MODE);
  formData.append('flow_id', flowId);
  formData.append('username', email);
  formData.append('password', password);

  const response = await requestPost(BASE_AUTHORIZE_URL + OIDC_AUTHORIZE_URL, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData.toString(),
  });

  if (!response.ok) {
    throw new AuthorizationError(response.status, response.statusText);
  }

  const result = await response.json();

  return authorizeToken(result.code, codeVerifier);
};
